<template src="./MonthlyReportDialog.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import HtmlEditor from "@/components/HtmlEditor";

export default defineComponent({
    components: { HtmlEditor },
    props: {
        visible: { type: Boolean, required: true },
        buttonSignature: { type: String, required: true },
        header: { type: String, required: true },
        mainContent: { type: String, required: true },
        templateSignature: { type: String, required: true }
    },
    emits: ["update:visible", "save"],
    data(props) {
        return {
            content: props.mainContent,
            signature: props.templateSignature
        };
    },
    computed: {
        valueSync: {
            get() {
                return this.visible;
            },
            set(value: boolean) {
                this.$emit("update:visible", value);
            }
        }
    },
    watch: {
        visible() {
            this.content = this.mainContent;
            this.signature = this.templateSignature;
        }
    },
    methods: {
        saveContent() {
            this.$emit("save", this.content, this.signature);
        },
        close() {
            this.valueSync = false;
        }
    }
});
</script>
